var _excluded = ["children", "className", "label", "left", "right", "size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import { kebabify } from "../../utils/helpers";
import Icons from "./icons.json";
import MagnaIcons from "./magnaIcons.js";
import { iconNameMap } from "./atomicMap.js";
import "./AIcon.scss";

/**
 * For icons that should not be styled as "regular",
 * this will add a class that unsets the `stroke` css value.
 * Some of the Phosphor icons need fill rather than stroke,
 * this allows those to be styled appropriately.
 */
var ignoreStrokeReplace = ["info", "negative", "positive", "warning", "cisco", "dots-three", "dots-six", "sort-up", "sort-down", "sort", "sort-empty", "last-page", "first-page", "malicious", "suspicious"];
var AIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    propsClassName = _ref.className,
    label = _ref.label,
    left = _ref.left,
    right = _ref.right,
    size = _ref.size,
    rest = _objectWithoutProperties(_ref, _excluded);
  var className = "a-icon";
  if (size && isNaN(size)) {
    className += " a-icon--size-".concat(size);
  }
  if (left) {
    className += " a-icon--left";
  }
  if (right) {
    className += " a-icon--right";
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  className += " a-icon--".concat(children);
  var ariaLabel = label || "".concat(children, " icon"),
    componentProps = _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      className: className,
      style: {},
      "aria-label": ariaLabel
    });
  if (size && !isNaN(size)) {
    componentProps.style.width = size;
  }
  var magneticIconDef;
  if (MagnaIcons[children]) {
    // Check if it's in magna icons

    magneticIconDef = MagnaIcons[children];
  } else if (iconNameMap[children]) {
    // check if we can map an atomic icon name to a magna icon
    magneticIconDef = MagnaIcons[iconNameMap[children]];
  } else {
    var kebabed = kebabify(children);
    magneticIconDef = MagnaIcons[kebabed];
    if (magneticIconDef) {
      componentProps.className += " a-icon--".concat(kebabed);
      componentProps["aria-label"] += " ".concat(kebabed);
    }
  }
  if (magneticIconDef) {
    var _magneticIconDef = magneticIconDef,
      iconProps = _magneticIconDef.props,
      xml = _magneticIconDef.xml;
    if (ignoreStrokeReplace.includes(children)) {
      componentProps.style.stroke = "none";
    }
    return /*#__PURE__*/React.createElement("svg", _extends({}, iconProps, componentProps), xml);
  }

  // Fallback to atomic icon for safety
  componentProps.className += " a-icon--atomic";
  return /*#__PURE__*/React.createElement("svg", _extends({}, componentProps, {
    viewBox: "0 0 16 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: Icons[children]
  }));
});
AIcon.propTypes = {
  /**
   * The `AIcon` component requires the icon name as the only child element.
   */
  children: PropTypes.string.isRequired,
  /**
   * Overrides the default `aria-label`, "[icon_name] icon".
   */
  label: PropTypes.string,
  /**
   * Adjusts margins if on the left side of text.
   */
  left: PropTypes.bool,
  /**
   * Adjusts margins if on the right side of text.
   */
  right: PropTypes.bool,
  /**
   * Sets a custom icon width.
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(["small", "medium", "large"])])
};
AIcon.displayName = "AIcon";
export default AIcon;